// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type EnvironmentVariablesForSiteQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
  runnerType?: Types.Maybe<Types.BuildRunnerType>;
}>;


export type EnvironmentVariablesForSiteQuery = (
  { __typename?: 'Query' }
  & { environmentVariablesForSite?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'Tag' }
    & Pick<Types.Tag, 'key' | 'value' | 'truncatedValue'>
  )>>> }
);

export type AllEnvironmentVariablesForSiteQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type AllEnvironmentVariablesForSiteQuery = (
  { __typename?: 'Query' }
  & { buildEnvironmentVariablesForSite?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'Tag' }
    & Pick<Types.Tag, 'key' | 'value' | 'truncatedValue'>
  )>>>, previewEnvironmentVariablesForSite?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'Tag' }
    & Pick<Types.Tag, 'key' | 'value' | 'truncatedValue'>
  )>>> }
);

export type UpdateEnvironmentVariablesForSiteMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
  environmentVariables: Array<Types.TagInput>;
  runnerType?: Types.Maybe<Types.BuildRunnerType>;
}>;


export type UpdateEnvironmentVariablesForSiteMutation = (
  { __typename?: 'Mutation' }
  & { updateEnvironmentVariablesForSite?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);

export type UpdateAllEnvironmentVariablesForSiteMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
  buildEnvironmentVariables: Array<Types.TagInput>;
  previewEnvironmentVariables: Array<Types.TagInput>;
}>;


export type UpdateAllEnvironmentVariablesForSiteMutation = (
  { __typename?: 'Mutation' }
  & { updateBuildEnvironmentVariablesForSite?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )>, updatePreviewEnvironmentVariablesForSite?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);


export const EnvironmentVariablesForSiteDocument = gql`
    query EnvironmentVariablesForSite($id: UUID!, $runnerType: BuildRunnerType) {
  environmentVariablesForSite(id: $id, runnerType: $runnerType) {
    key
    value
    truncatedValue
  }
}
    `;

/**
 * __useEnvironmentVariablesForSiteQuery__
 *
 * To run a query within a React component, call `useEnvironmentVariablesForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentVariablesForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentVariablesForSiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      runnerType: // value for 'runnerType'
 *   },
 * });
 */
export function useEnvironmentVariablesForSiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EnvironmentVariablesForSiteQuery, EnvironmentVariablesForSiteQueryVariables>) {
        return ApolloReactHooks.useQuery<EnvironmentVariablesForSiteQuery, EnvironmentVariablesForSiteQueryVariables>(EnvironmentVariablesForSiteDocument, baseOptions);
      }
export function useEnvironmentVariablesForSiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EnvironmentVariablesForSiteQuery, EnvironmentVariablesForSiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EnvironmentVariablesForSiteQuery, EnvironmentVariablesForSiteQueryVariables>(EnvironmentVariablesForSiteDocument, baseOptions);
        }
export type EnvironmentVariablesForSiteQueryHookResult = ReturnType<typeof useEnvironmentVariablesForSiteQuery>;
export type EnvironmentVariablesForSiteLazyQueryHookResult = ReturnType<typeof useEnvironmentVariablesForSiteLazyQuery>;
export type EnvironmentVariablesForSiteQueryResult = ApolloReactCommon.QueryResult<EnvironmentVariablesForSiteQuery, EnvironmentVariablesForSiteQueryVariables>;
export const AllEnvironmentVariablesForSiteDocument = gql`
    query AllEnvironmentVariablesForSite($id: UUID!) {
  buildEnvironmentVariablesForSite: environmentVariablesForSite(
    id: $id
    runnerType: BUILDS
  ) {
    key
    value
    truncatedValue
  }
  previewEnvironmentVariablesForSite: environmentVariablesForSite(
    id: $id
    runnerType: PREVIEW
  ) {
    key
    value
    truncatedValue
  }
}
    `;

/**
 * __useAllEnvironmentVariablesForSiteQuery__
 *
 * To run a query within a React component, call `useAllEnvironmentVariablesForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEnvironmentVariablesForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEnvironmentVariablesForSiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllEnvironmentVariablesForSiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllEnvironmentVariablesForSiteQuery, AllEnvironmentVariablesForSiteQueryVariables>) {
        return ApolloReactHooks.useQuery<AllEnvironmentVariablesForSiteQuery, AllEnvironmentVariablesForSiteQueryVariables>(AllEnvironmentVariablesForSiteDocument, baseOptions);
      }
export function useAllEnvironmentVariablesForSiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllEnvironmentVariablesForSiteQuery, AllEnvironmentVariablesForSiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<AllEnvironmentVariablesForSiteQuery, AllEnvironmentVariablesForSiteQueryVariables>(AllEnvironmentVariablesForSiteDocument, baseOptions);
        }
export type AllEnvironmentVariablesForSiteQueryHookResult = ReturnType<typeof useAllEnvironmentVariablesForSiteQuery>;
export type AllEnvironmentVariablesForSiteLazyQueryHookResult = ReturnType<typeof useAllEnvironmentVariablesForSiteLazyQuery>;
export type AllEnvironmentVariablesForSiteQueryResult = ApolloReactCommon.QueryResult<AllEnvironmentVariablesForSiteQuery, AllEnvironmentVariablesForSiteQueryVariables>;
export const UpdateEnvironmentVariablesForSiteDocument = gql`
    mutation UpdateEnvironmentVariablesForSite($id: UUID!, $environmentVariables: [TagInput!]!, $runnerType: BuildRunnerType) {
  updateEnvironmentVariablesForSite(
    id: $id
    environmentVariables: $environmentVariables
    runnerType: $runnerType
  ) {
    success
    message
  }
}
    `;
export type UpdateEnvironmentVariablesForSiteMutationFn = ApolloReactCommon.MutationFunction<UpdateEnvironmentVariablesForSiteMutation, UpdateEnvironmentVariablesForSiteMutationVariables>;

/**
 * __useUpdateEnvironmentVariablesForSiteMutation__
 *
 * To run a mutation, you first call `useUpdateEnvironmentVariablesForSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnvironmentVariablesForSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnvironmentVariablesForSiteMutation, { data, loading, error }] = useUpdateEnvironmentVariablesForSiteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentVariables: // value for 'environmentVariables'
 *      runnerType: // value for 'runnerType'
 *   },
 * });
 */
export function useUpdateEnvironmentVariablesForSiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEnvironmentVariablesForSiteMutation, UpdateEnvironmentVariablesForSiteMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEnvironmentVariablesForSiteMutation, UpdateEnvironmentVariablesForSiteMutationVariables>(UpdateEnvironmentVariablesForSiteDocument, baseOptions);
      }
export type UpdateEnvironmentVariablesForSiteMutationHookResult = ReturnType<typeof useUpdateEnvironmentVariablesForSiteMutation>;
export type UpdateEnvironmentVariablesForSiteMutationResult = ApolloReactCommon.MutationResult<UpdateEnvironmentVariablesForSiteMutation>;
export type UpdateEnvironmentVariablesForSiteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEnvironmentVariablesForSiteMutation, UpdateEnvironmentVariablesForSiteMutationVariables>;
export const UpdateAllEnvironmentVariablesForSiteDocument = gql`
    mutation UpdateAllEnvironmentVariablesForSite($id: UUID!, $buildEnvironmentVariables: [TagInput!]!, $previewEnvironmentVariables: [TagInput!]!) {
  updateBuildEnvironmentVariablesForSite: updateEnvironmentVariablesForSite(
    id: $id
    environmentVariables: $buildEnvironmentVariables
    runnerType: BUILDS
  ) {
    success
    message
  }
  updatePreviewEnvironmentVariablesForSite: updateEnvironmentVariablesForSite(
    id: $id
    environmentVariables: $previewEnvironmentVariables
    runnerType: PREVIEW
  ) {
    success
    message
  }
}
    `;
export type UpdateAllEnvironmentVariablesForSiteMutationFn = ApolloReactCommon.MutationFunction<UpdateAllEnvironmentVariablesForSiteMutation, UpdateAllEnvironmentVariablesForSiteMutationVariables>;

/**
 * __useUpdateAllEnvironmentVariablesForSiteMutation__
 *
 * To run a mutation, you first call `useUpdateAllEnvironmentVariablesForSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllEnvironmentVariablesForSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllEnvironmentVariablesForSiteMutation, { data, loading, error }] = useUpdateAllEnvironmentVariablesForSiteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      buildEnvironmentVariables: // value for 'buildEnvironmentVariables'
 *      previewEnvironmentVariables: // value for 'previewEnvironmentVariables'
 *   },
 * });
 */
export function useUpdateAllEnvironmentVariablesForSiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAllEnvironmentVariablesForSiteMutation, UpdateAllEnvironmentVariablesForSiteMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateAllEnvironmentVariablesForSiteMutation, UpdateAllEnvironmentVariablesForSiteMutationVariables>(UpdateAllEnvironmentVariablesForSiteDocument, baseOptions);
      }
export type UpdateAllEnvironmentVariablesForSiteMutationHookResult = ReturnType<typeof useUpdateAllEnvironmentVariablesForSiteMutation>;
export type UpdateAllEnvironmentVariablesForSiteMutationResult = ApolloReactCommon.MutationResult<UpdateAllEnvironmentVariablesForSiteMutation>;
export type UpdateAllEnvironmentVariablesForSiteMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAllEnvironmentVariablesForSiteMutation, UpdateAllEnvironmentVariablesForSiteMutationVariables>;
